<template>
  <div id="wffReport">
    <Printer title=" ">
      <template v-slot:printContent>
        <div class="h1 pb-3" style="font-family: Raleway; font-weight: bold">
          World Friendship Fund Transmittal
        </div>
        <div class="row pt-3">
          <div class="col-7" />
          <div class="col-5 pl-0">
            Date:
            <span style="font-weight: bold; text-decoration: underline">{{
              theDate
            }}</span>
          </div>
        </div>
        <div class="row mb-5">
          <div class="col-7">
            International Department<br>
            Boy Scouts of America<br>
            1325 West Walnut Hill Lane<br>
            P.O. Box 15209<br>
            Irving, Texas 75015-2079
          </div>
          <div class="col-5">
            <div class="row mt-3">
              <div
                class="col-5 p-2 text-center"
                style="border: 2px solid black"
              >
                Account No.<br>
                6400-64003
              </div>
            </div>
          </div>
        </div>
        <p>
          The participants of Wood Badge Course No.
          <span style="font-weight: bold; text-decoration: underline">{{
            $root.courseName
          }}</span>
          have made a contribution to extend world friendship in a personal way.
        </p>
        <p>
          A check to the World Friendship Fund in the amount of $
          <span style="font-weight: bold; text-decoration: underline">{{
            reportInfo.Amount
          }}</span>
          is enclosed.
        </p>
        <div class="row">
          <div class="col-2">
            Signature
          </div>
          <div
            class="col-6"
            style="border-bottom: 1px solid black"
          />
          <div class="col-4" />
        </div>
        <div class="row mb-3">
          <div class="col-2" />
          <div class="col-6 text-center">
            <small>Course Director</small>
          </div>
          <div class="col-4" />
        </div>
        <div class="row">
          <div class="col-2">
            Signature
          </div>
          <div
            class="col-6"
            style="border-bottom: 1px solid black"
          />
          <div class="col-4" />
        </div>
        <div class="row mb-3">
          <div class="col-2" />
          <div class="col-6 text-center">
            <small>Scout Executive</small>
          </div>
          <div class="col-4" />
        </div>
        <div class="row">
          <div class="col-3">
            Council name and No.
          </div>
          <div
            class="col-4"
            style="border-bottom: 1px solid black"
          >
            {{ reportInfo.CouncilName }} - {{ reportInfo.CouncilNumber }}
          </div>
          <div class="col-5" />
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import reportsApi from '@/services/api/reports.js'
import formatter from '@/services/formatter.js'
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'ReportWorldFriendshipFund',
  components: {
    Printer
  },
  data: function () {
    return {
      reportInfo: {
        DateOf: null,
        CouncilName: null,
        CouncilNumber: null,
        Amount: null
      }
    }
  },
  computed: {
    theDate: function () {
      return formatter.formatAsDate(this.reportInfo.DateOf)
    }
  },
  mounted: function () {
    reportsApi
      .getWffCollectionsReport(this.$root.courseKey)
      .then(response => {
        this.reportInfo = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
